import { Model } from "@bryntum/schedulerpro";
import {HasProjectMixin} from "./mixins/HasProjectMixin.jsx";

export class Team extends HasProjectMixin(Model) {
  static get $name() {
    return "Team";
  }

  static get configurable() {
    return [
        "name",
        "color",
        "order",
    ];
  }
}

Team.exposeProperties();